module.exports = __webpack_public_path__ + "img/commission3.fc1c8456.webp";